export * from './lib/app-client-shared-components-menu-content-data-access.module';
